<template>
  <div>
    <b-form-group :label="label" :label-for="id" :description="description">
      <b-form-spinbutton
          :id="id"
          v-model="localValue"
          :min=min
          :max=max
          :step=step
          :readonly="readonly"
        ></b-form-spinbutton>
      <b-form-invalid-feedback v-if="errorMsg">
        {{ errorMsg }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-input-group-append v-if="hasAppendSlot">
      <b-input-group-text>
        <slot name="append"></slot>
      </b-input-group-text>
    </b-input-group-append>
  </div>
</template>

<script>
import { BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BInputGroupText, BFormInvalidFeedback, BFormSpinbutton } from 'bootstrap-vue'

const compName = 'base-spin-input'

export default {
  name: compName,
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText,
    BFormInvalidFeedback,
    BFormSpinbutton
  },
  props: {
    value: Number,
    label: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMsg: {
      type: String,
      required: false,
      default: null
    },
    min: {
      type: String,
      required: true,
      default: 0
    },
    max: {
      type: String,
      required: true,
      default: 100
    },
    step: {
      type: String,
      required: true,
      default: 1
    }
  },
  data () {
    return {
      id: null,
      localValue: null
    }
  },
  mounted () {
    this.id = `${compName}${this._uid.toString()}`
  },
  created () {
    this.localValue = this.value
    this.$watch('value', value => {
      this.localValue = value
    })
    this.$watch('localValue', value => {
      this.$emit('input', value)
      this.$emit('change', value)
    })
  },
  computed: {
    hasAppendSlot () {
      return this.$slots.append !== undefined
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseSpinInput.vue